import { CardLogicReadOnlyPlugin } from '../plugins/CardLogic/CardLogicReadOnlyPlugin';
import { IELTSScoreConverterReadOnlyPlugin } from '../../DolEditor/elements/ielts-score-converter/IeltsScoreConverterPlugin';
import { IELTSCalculatorReadOnlyPlugin } from '../../DolEditor/elements/ielts-calculator/IELTSCalculatorReadOnlyPlugin';
import { IeltsCalendarComputerBasedReadOnlyPlugin } from '../plugins/SpecialObject/IeltsCalendar/ComputerBased/IeltsCalendarComputerBasedReadOnlyPlugin';
import { IeltsPurposeConverterReadOnlyPlugin } from '../plugins/SpecialObject/IeltsConverter/Purpose/IeltsPurposeConverterReadOnlyPlugin';
import { SpecialObjectReadOnlyPlugin } from '../plugins/SpecialObject/SpecialObjectReadOnlyPlugin';
import { SampleSpecialObjectReadOnlyPlugin } from '../plugins/SpecialObject/IeltsSample/SpecialObjectReadOnlyPlugin';
import { PagerExamScheduleReadOnlyPlugin } from '../../DolEditor/elements/paper-exam-schedule/PagerExamScheduleReadOnlyPlugin';

export const getAllSpecialObjectReadOnlyPlugins = ({ isReadOnly }) => [
  // special object
  CardLogicReadOnlyPlugin(), //
  IELTSScoreConverterReadOnlyPlugin({ isPreview: isReadOnly }),
  IELTSCalculatorReadOnlyPlugin(),
  IeltsCalendarComputerBasedReadOnlyPlugin({ isReadOnly }),
  IeltsPurposeConverterReadOnlyPlugin({ isReadOnly }),
  SpecialObjectReadOnlyPlugin({ isReadOnly }), // book, course
  SampleSpecialObjectReadOnlyPlugin({ isReadOnly }), // writing/speaking sample
  PagerExamScheduleReadOnlyPlugin({ isPreview: isReadOnly }),
];
